<template>
    <transition name="transform">
        <div
            v-if="visible"
            :class="['visual-panel', {'visual-panel_theme_flat': dataStep.step === 'flat'}]">
            <div class="visual-panel__header">
                <div class="visual-panel__title">
                    {{ panel.title }}

                    <div v-if="panel.action" class="visual-panel__label action-label">
                        {{ panel.action }}
                    </div>
                </div>
                <div v-if="panel.deadline" class="visual-panel__deadline">{{ panel.deadline }}</div>
            </div>

            <div class="visual-panel__close">
                <button class="button-close" aria-label="Закрыть" @click="remove">
                    <iconPanelClose/>
                </button>
            </div>

            <ul v-if="dataStep.step !== 'flat'" class="visual-panel__params">
                <li
                    v-for="item in panel.params"
                    :key="item.price"
                    :class="['visual-panel__params-item', {'is-disabled': item.disabled}]">

                    <div v-if="item.flats" class="visual-panel__sign">{{ item.flatsMob }}</div>

                    <div
                        v-if="item.price"
                        class="visual-panel__value">
                        {{ convertPriceRank(item.price) }}
                    </div>

                    <div v-if="item.amount >= 0" class="visual-panel__amount">{{ item.amount }}</div>
                </li>
            </ul>

            <ul v-if="dataStep.step === 'flat' &&
                (panel.status === 'sale' || panel.status === 'booked')"
                :class="['visual-panel__params', {'is-booked': panel.status === 'booked'}]">
                <li
                    v-for="item in panel.params"
                    :key="item.price"
                    class="visual-panel__params-item"
                >
                    <div v-if="item.area" class="visual-panel__area">
                        {{item.area}}м<sup>2</sup>
                    </div>

                    <div v-if="item.isBooked === true" class="visual-panel__booked">
                        Забронирована
                    </div>

                    <div v-if="item.price" class="visual-panel__price">
                        {{ convertPriceDigit(item.price) }}
                    </div>

                    <div v-if="item.priceOld" class="visual-panel__price-old">
                        {{ convertPriceDigit(item.priceOld) }}
                    </div>

                    <div v-if="item.price && panel.action" class="visual-panel__label action-label">
                        -{{ panel.action }}%
                    </div>
                </li>
            </ul>

            <ul v-if="dataStep.step === 'flat' && panel.status === 'sold'" class="visual-panel__params sold">
                <li>
                    <div class="visual-panel__sold">
                        Квартира продана
                    </div>
                </li>
            </ul>

            <ul v-if="dataStep.step === 'flat' && panel.status === 'notSale'" class="visual-panel__params no-sales">
                <li>
                    <div class="visual-panel__not-sale">
                        Квартира не в продаже
                    </div>
                </li>
            </ul>

            <div v-if="!panel.status || panel.status === 'sale'" class="visual-panel__next">
                <button class="visual-panel__next-button" @click="toNextStep(panel.link)">
                    <span class="visual-panel__next-mobile">Смотреть</span>
                </button>
            </div>
        </div>
    </transition>
</template>

<style lang="scss">
    @import "./Panel.scss";
</style>

<script>
import iconPanelClose from '../Icons/icon-panel-close';
import {mapGetters} from 'vuex';
import Observer from 'common/scripts/observer';
import Utils from 'common/scripts/utils';

const observer = new Observer();

export default {
    data() {
        return {
            visible: false
        };
    },

    components: {
        iconPanelClose
    },

    computed: {
        ...mapGetters({
            dataStep: 'GET_DATA_STEP'
        })
    },

    watch: {
        dataStep() {
            this.remove();
        }
    },

    mounted() {
        observer.subscribe('mouseoverPanel', (data) => {
            this.insert();
            this.setData(data);
        });

        observer.subscribe('mouseleavePanel', () => {
            this.remove();
        });
    },

    methods: {
        insert() {
            this.visible = true;
        },

        remove() {
            this.visible = false;
        },

        setData(data) {
            const targetId = data.id;

            const currentData = data.elements.find((element) => {
                const id = element.id;

                return id === targetId ? element : false;
            });

            this.panel = {
                type: data.type,
                link: data.link,
                ...currentData.tooltip
            };
        },

        convertPriceRank(price) {
            if (Number(price)) {
                return `от ${Utils.convertToDigit(Utils.convertToRank(price, 1000000).toFixed(1))} млн`;
            }

            return price;
        },

        convertPriceDigit(price) {
            if (Number(price)) {
                return `${Utils.convertToDigit(price)} руб`;
            }

            return Utils.convertToDigit(price);
        },

        toNextStep(link) {
            observer.publish('clicknextPanel', link);
        }
    }
};
</script>
